import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import { ModuleRegistry } from '@ag-grid-community/core';
import { GridChartsModule } from '@ag-grid-enterprise/charts';
import { ExcelExportModule } from '@ag-grid-enterprise/excel-export';
import { FiltersToolPanelModule } from '@ag-grid-enterprise/filter-tool-panel';
import { MenuModule } from '@ag-grid-enterprise/menu';
import { RowGroupingModule } from '@ag-grid-enterprise/row-grouping';
import { ServerSideRowModelModule } from '@ag-grid-enterprise/server-side-row-model';
import { SetFilterModule } from '@ag-grid-enterprise/set-filter';
import { SideBarModule } from '@ag-grid-enterprise/side-bar';
import { StatusBarModule } from '@ag-grid-enterprise/status-bar';
import { NgModule } from '@angular/core';
import { TestBed } from '@angular/core/testing';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule, NoopAnimationsModule } from '@angular/platform-browser/animations';
import {
  CoreExportModules,
  CoreImportModules,
  CoreModuleDeclarations,
  CoreTestingModules,
} from '@uigy/core/model/core-module-env-config';
import { LanguageModule } from '@uigy/language.module';
import { MiniLayoutWrapperComponent } from '@uigy/shared/components/mini-layout-wrapper/mini-layout-wrapper.component';

import { Services } from '@uigy/shared/services';

@NgModule({
  imports: [
    CoreImportModules,
    LanguageModule.forRoot(),
    MiniLayoutWrapperComponent,
  ],
  declarations: [CoreModuleDeclarations],
  exports: [
    CoreExportModules,
    CoreModuleDeclarations,
    LanguageModule
  ]
})
export class CoreModule {
  constructor() {
    ModuleRegistry.registerModules([ClientSideRowModelModule, ServerSideRowModelModule, GridChartsModule, RowGroupingModule, MenuModule, SideBarModule, SetFilterModule, StatusBarModule, ExcelExportModule, FiltersToolPanelModule]);
  }

  static forTest(NgModuleSetting: NgModule = {}): TestBed {
    const imports = NgModuleSetting.imports;
    imports ? imports.push([CoreModule]) : NgModuleSetting.imports = [CoreModule];
    return (TestBed.configureTestingModule(NgModuleSetting).overrideModule(CoreModule, {
      remove: {
        imports: [
          LanguageModule,
          BrowserModule,
          BrowserAnimationsModule,
        ],
        exports: [LanguageModule]
      },
      add: {
        providers: [NoopAnimationsModule, Services],
        imports: [CoreTestingModules,  LanguageModule.forTest()],
        exports: [CoreModuleDeclarations,  CoreTestingModules, LanguageModule]
      }
    }));
  }
}
